/** Generated by @jobilla/openapi-codegen. Do not edit manually. */

/** @see backend/nexus/modules/Campaign/Enums/CandidateProfileSection.php */
export const candidateProfileSection = {
	work_history: 'work_history',
	education: 'education',
	licenses: 'licenses',
} as const

/** @see backend/nexus/modules/Campaign/Enums/CandidateProfileSection.php */
export type CandidateProfileSection = (typeof candidateProfileSection)[keyof typeof candidateProfileSection]
